import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { SelfieAttributeComparison } from 'dashboard/models/check';

export const computeSelfieAttributeComparisonMetadata = (
  check: SelfieAttributeComparison,
): CheckMetadata => {
  const {
    'selfie-comparison-passed-count': passedCount,
    'selfie-comparison-total-count': totalCount,
  } = check.metadata || {};

  if (passedCount != null && totalCount != null) {
    return {
      metadata: createSimpleCheckMetadataArray([
        {
          label: 'Matched Selfies',
          value: `${passedCount}`,
        },
        {
          label: 'Total Selfies Compared',
          value: `${totalCount}`,
        },
      ]),
      hideIfVerificationPassed: false,
    };
  } else {
    return {
      metadata: [],
      hideIfVerificationPassed: false,
    };
  }
};
